import { gql } from '@apollo/client';

export const GET_PROGRAMME_REPORTERS = gql`
  query GetProgrammeReporters($input: ProgrammeReportersInput!) {
    programmeReporters: getProgrammeReporters(input: $input) {
      id
      startDate
      endDate
      status
      assignees {
        id
        firstName
        lastName
      }
      organisation {
        id
        funder {
          id
          name
        }
        serviceProvider {
          id
          name
        }
        institution {
          id
          name
        }
      }
      programme {
        id
      }
      intervention {
        id
      }
    }
  }
`;
